export const forceModifyCountryCodeToLanguage = (country) => {
  // if (country === 'IE') {
  //   return 'GB';
  // } else {
  //   return country;
  // }
  return country;
};
